<template>
	<div class="c5">
		<main class="page-main-content">
			<div class="first">
				<div class="img-wrap">
					<img
						class="c5black"
						src="../assets/image/c5/black.png"
						alt=""
					/>
				</div>
				<div class="section1-text">
					<h3 class="title p1 textfade textfade1">{{text.first.title}}</h3>
					<p class="p2 text textfade textfade2">
						<span v-for="(item, key) in text.first.tips" :key="key">{{item}}</span>
					</p>
				</div>
			</div>
			<div class="tabscontent">
				<div id="tab1">
					<div class="section section2">
						<div class="maxwidth">
							<div class="desc-text">
								<h3 class="title textfade">{{text.second.title}}</h3>
								<p class="text textfade">{{text.second.text}}</p>
								<ul class="textfade desclist">
									<li v-for="(item, key) in text.second.tips" :key="key">
										<p class="big" v-if="key < 2">
											<em>{{item[0]}}</em><span>{{item[1]}}</span>
										</p>
										<i v-else class="desicon icon2"></i>
										<p>{{item[2]}}</p>
									</li>
								</ul>
							</div>
						</div>
						<div
							class="swiper-container swiper-no-swiping"
							id="c5swiper"
						>
							<div class="swiper-wrapper">
								<div class="swiper-slide picslide slide1">
									<picture
										><source
											srcset="../assets/image/c5/fixedPlane-mobile.png"
											media="(max-width: 600px)"/>
										<img
											class="fixedplane"
											src="../assets/image/c5/fixedPlane.png"
											alt=""
									/></picture>
								</div>
								<div class="swiper-slide picslide slide2">
									<img
										class="multiplane"
										src="../assets/image/c5/multiPlane.png"
										alt=""
									/>
								</div>
							</div>
						</div>
					</div>
					<div class="section section3">
						<div class="maxwidth">
							<div class="desc-img">
								<img
									src="../assets/image/c5/newcamera.png"
									alt=""
								/>
							</div>
							<div class="desc-text">
								<h3 class="title textfade">{{text.third.title}}</h3>
								<p class="text textfade">{{text.third.text}}</p>
								<ul class="desclist textfade">
									<li>
										<i class="desicon icon3"></i>
										<p>{{text.third.tips[0][1]}}</p>
									</li>
									<li>
										<p class="big"><em>{{text.third.tips[1][0]}}</em></p>
										<p>{{text.third.tips[1][1]}}</p>
									</li>
								</ul>
							</div>
						</div>
					</div>
					<div class="section section4">
						<div class="maxwidth">
							<div class="desc-text">
								<h3 class="title textfade">{{text.forth.title}}</h3>
								<p class="text textfade">{{text.forth.text}}</p>
							</div>
							<div class="desc-img">
								<img
									class="imgbg"
									src="../assets/image/c5/recoverybg.png"
									alt=""
								/>
								<div class="rada"></div>
								<img
									class="imgc5"
									src="../assets/image/c5/recovery.png"
									alt=""
								/>
							</div>
						</div>
					</div>
					<div class="section section5">
						<div class="maxwidth">
							<div class="desc-img">
								<div class="img-wrap">
									<img
										class="imgbg"
										src="../assets/image/c5/uv.png"
										alt=""
									/>
									<div class="circle-wrap">
										<i
											class="small-circle small-circle1"
										></i
										><i
											class="small-circle small-circle2"
										></i
										><i
											class="small-circle small-circle3"
										></i
										><i
											class="small-circle small-circle4"
										></i
										><canvas
											id="canvas"
											width="250"
											height="250"
										></canvas>
									</div>
								</div>
							</div>
							<div class="desc-text">
								<h3 class="title textfade">{{text.fifth.title}}</h3>
								<p class="text textfade">{{text.fifth.text}}</p>
							</div>
						</div>
					</div>
					<div class="section section6">
						<div class="maxwidth">
							<div class="desc-text">
								<h3 class="title textfade">{{text.sixth.title}}</h3>
								<p class="text textfade">{{text.sixth.text}}</p>
								<ul class="desclist textfade">
									<li v-for="(item, i) in text.sixth.tips" :key="i">
										<i :class="`desicon icon6-${i+1}`"></i>
										<p>{{item}}</p>
									</li>
								</ul>
							</div>
							<div class="desc-img">
								<picture
									><source
										srcset="../assets/image/c5/human-mobile.png"
										media="(max-width: 960px)"/>
									<img
										class="human"
										src="../assets/image/c5/human.png"
										alt=""
								/></picture>
							</div>
						</div>
					</div>
					<div class="section section7">
						<div class="maxwidth">
							<div class="desc-img">
								<picture
									><source
										srcset="../assets/image/c5/pc-mobile.png"
										media="(max-width: 600px)"/>
									<img
										class="human"
										src="../assets/image/c5/pc.png"
										alt=""
								/></picture>
							</div>
							<div class="desc-text">
								<h3 class="title textfade">{{text.seventh.title}}</h3>
								<p class="text textfade">{{text.seventh.text}}</p>
								<ul class="desclist textfade">
									<li v-for="(v, k) in text.seventh.tips" :key="k">
										<i :class="`desicon icon7-${k + 1}`"></i>
										<p>{{v}}</p>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
				<div class="c5tab2" id="tab2">
					<div class="tab-wrap">
						<h3 class="tab-title title" id="tabtitle">{{text.paramsTitle}}</h3>
						<table v-for="(item, i) in Object.keys(text.params)" :key="i">
							<caption>
								{{item}}
							</caption>
							<tbody>
								<tr v-for="(v,k) in Object.keys(text.params[item])" :key="k+v">
									<td>{{v}}</td>
									<td>{{text.params[item][v]}}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</main>
		<foot></foot>
	</div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import { secondNav } from '@/js/utils'
import { C5 } from '@/js/text';
import 'swiper/css/swiper.min.css'
import $ from 'jquery'
import Swiper from 'swiper'

export default {
	name: 'c5',
	metaInfo: {
		meta: [{
			name: 'keywords', 
			content: '相机,倾斜摄影,像素,分辨率,图片,镜头,拍照'
		},{
			name: 'description', 
			content: '灵境C5是一款行业级倾斜摄影相机，6K分辨率镜头、850g超轻重量、1.2亿像素，内置智能自检系统，开机智能自检，影像数据智能分组。'
		}]
	},
	data() {
		return {
			width: 0,
			swiper: null
		}
	},
	computed: {
		...mapState(['headerStyle']),
		text() {
			return this.$route.params.lang === 'CN' ? C5.CN : C5.EN
		}
	},
	components: {
		Foot: () => import('@/components/footer.vue')
	},
	methods: {
		...mapMutations(['setHeaderStyle']),
		resize() {
			this.width = $(window).width()
		},
		initSwiper() {
			this.swiper = new Swiper('.swiper-container', {
				autoplay: true,
				loop: true,
				observer: true,
				observeParents: true
			})
		},
		getRads(degrees) {
			return (Math.PI * degrees) / 180
		},
		secondAnimate(blueCanvas) {
			let blue = blueCanvas.getContext('2d')
			let b_x = blueCanvas.width / 2,
				b_y = blueCanvas.height / 2,
				b_w = blueCanvas.width,
				b_h = blueCanvas.height,
				bluePerc_1 = 135,
				bluePerc_1_1 = 135,
				bluePerc_2 = 180,
				bluePerc_2_2 = 180,
				bluePerc_2_dash = 180,
				bluePerc_3 = 45,
				bluePerc_3_3 = 45,
				bluePerc_3_dash = 45

			animate()

			function animate() {
				blue.clearRect(0, 0, b_w, b_h)

				//蓝色虚线内圈
				blue.beginPath()
				blue.lineWidth = 1
				blue.lineCap = 'butt'
				blue.strokeStyle = '#4B83DD'
				blue.setLineDash([2, 5])
				if (bluePerc_1 < 495) {
					blue.arc(
						b_x,
						b_y,
						100,
						getRads(135),
						getRads(bluePerc_1),
						false
					)
				} else {
					blue.arc(
						b_x,
						b_y,
						100,
						getRads((bluePerc_1_1 += 1)),
						getRads(bluePerc_1),
						false
					)
				}
				blue.filter = 'blur(0)'
				blue.stroke()
				blue.closePath()

				//内圆-缺口
				blue.beginPath()
				blue.lineWidth = 3
				blue.strokeStyle = '#5AF8FF'
				blue.lineCap = 'round'
				blue.setLineDash([150, 150])
				if (bluePerc_2 > -180) {
					blue.arc(b_x, b_y, 110, getRads(180), getRads(bluePerc_2), true)
				} else {
					blue.arc(
						b_x,
						b_y,
						110,
						getRads((bluePerc_2_2 -= 1)),
						getRads(bluePerc_2),
						true
					)
				}
				blue.filter = 'blur(0)'
				blue.stroke()
				blue.closePath()

				//内圆-边框
				blue.beginPath()
				blue.lineWidth = 1
				blue.lineCap = 'butt'
				blue.strokeStyle = '#5AF8FF'
				blue.setLineDash([])
				blue.arc(b_x, b_y, 110, getRads(180), getRads(bluePerc_2), true)
				blue.filter = 'blur(0)'
				blue.stroke()
				blue.closePath()

				//外圆-缺口
				blue.beginPath()
				blue.lineWidth = 3
				blue.strokeStyle = '#4B83DD'
				blue.lineCap = 'round'
				blue.setLineDash([175, 175])
				if (bluePerc_3 < 406) {
					blue.arc(b_x, b_y, 123, getRads(45), getRads(bluePerc_3), false)
				} else {
					blue.arc(
						b_x,
						b_y,
						123,
						getRads((bluePerc_3_3 += 1)),
						getRads(bluePerc_3),
						false
					)
				}
				blue.filter = 'blur(0)'
				blue.stroke()
				blue.closePath()

				//外圆-边框
				blue.beginPath()
				blue.lineWidth = 1
				blue.strokeStyle = '#4B83DD'
				blue.setLineDash([])
				blue.arc(b_x, b_y, 123, getRads(45), getRads(bluePerc_3), false)
				blue.filter = 'blur(0)'
				blue.stroke()
				blue.closePath()

				if (bluePerc_1 < 495) {
					bluePerc_1 += 10
				} else {
					bluePerc_1 += 1
				}
				if (bluePerc_2 > -180) {
					bluePerc_2 -= 10
				} else {
					bluePerc_2 -= 1
				}

				bluePerc_2_dash += 10

				if (bluePerc_3 < 406) {
					bluePerc_3 += 10
				} else {
					bluePerc_3 += 1
				}

				bluePerc_3_dash -= 10
				requestAnimationFrame(function() {
					animate()
				})
			}
		},
		size(width) {
		let titlefont = document.getElementById('tabtitle')
		if (titlefont && width <= 600) {
			titlefont.innerHTML =
				"<p class='tit1'>灵境C5</p><p class='tit2'>技术参数</p>"
		} else if(titlefont){
			titlefont.innerHTML = '灵境C5-技术参数'
		}
	},
	initEvent() {
		let page = document.querySelectorAll('.section')
		let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
		if (this.width > 600) {
			if (
				scrollTop + $('.first').height() >
				$('.section2').offset().top
			) {
				$('.section2 h3').addClass('textfade1')
				$('.section2 .desc-text>p').addClass('textfade2')
				$('.section2 .desclist').addClass('textfade3')
			}
		}
		for (let i = 0; i < page.length; i++) {
			if(i === 0 && scrollTop > $(page[0]).height() / 3) {
				$(page[0]).find('h3').addClass('textfade1')
				$(page[0]).find('.desc-text>p').addClass('textfade2')
				if ($(page[0]).find('.desclist').length > 0) {
					$(page[0]).find('.desclist').addClass('textfade3')
				}
				
			}else if (
				scrollTop +
					$(page[i]).prev().height() > $(page[i]).offset().top) {
				
				$(page[i]).find('h3').addClass('textfade1')
				$(page[i]).find('.desc-text>p').addClass('textfade2')
				if ($(page[i]).find('.desclist').length > 0) {
					$(page[i]).find('.desclist').addClass('textfade3')
				}
			}
		}
		if(scrollTop >= $(page[2]).offset().top - 40 && scrollTop < $(page[3]).offset().top - 40 || scrollTop > $('.footer').offset().top - 40) {
			this.setHeaderStyle({headerStyle: 'light'})
		}
		if(scrollTop < $(page[2]).offset().top - 40 || scrollTop >= $(page[3]).offset().top - 40 && scrollTop <= $('.footer').offset().top - 40) {
			this.setHeaderStyle({headerStyle: 'dark'})
		}


	}
	},
	mounted() {
		this.initSwiper()
		this.setHeaderStyle({headerStyle: 'dark'})
		window.addEventListener('scroll', this.initEvent)
		window.addEventListener('resize',this.resize)
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.initEvent)
		window.removeEventListener('resize',this.resize)
	}
}
</script>
<style lang="scss" scoped>
@import '../assets/css/c5.scss';
</style>
